export default {
    bindings: {
        arrivals: '<',
        loading: '<',
        date: '@'
    },
    controller: 'arrivalListController',
    template: require('../views/arrival.list.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/guests/components/arrival.list.component.js